import { useEffect } from 'react';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';
import { useAppEnvironment } from './use-app-environment.hook';

export const useEnvironmentTitle = () => {
    const config = useAppConfigContext();
    const { activeEnv: currentEnv } = useAppEnvironment();

    useEffect(() => {
        const isVivliOrg = window.location.host.toLowerCase().includes('vivli.org');

        if (!isVivliOrg) {
            //DEV-1133: was `config.queryUri.split('-')[1]`, which produced the same values because
            //the search services are named vivli-<env>-cus-srch. That URL no longer reaches the browser.
            const activeEnv = config.envShortName;
            const isLocal = currentEnv === 'local';

            document.title = `Vivli - ${isLocal ? 'LOCAL ' : ''}${activeEnv?.toUpperCase()}`;
        }
    }, [config.envShortName, currentEnv]);
};
